<template>
<div>
    <div class="d-flex flex-column-fluid">
        <!--begin::Container-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col-lg-12 col-xl-12">
                            <div class="card card-custom gutter-b bg-transparent shadow-none border-0">
                                <div class="card-header align-items-center  border-bottom-dark px-0">
                                    <div class="card-title mb-0">
                                        <h3 class="card-label mb-0 font-weight-bold text-body">
                                            Store
                                        </h3>
                                    </div>
                                    <div class="icons d-flex">
                                        <button class="btn ml-2 p-0 kt_notes_panel_toggle" data-toggle="tooltip" title="" data-placement="right" data-original-title="Check out more demos" v-if="$parent.permissions.includes('blog-manage')">
                                            <span class="bg-secondary h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center  rounded-circle shadow-sm " v-on:click="
                                                        display_form = !display_form
                                                    ">
                                                <svg width="25px" height="25px" viewBox="0 0 16 16" class="bi bi-plus white" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"></path>
                                                </svg>
                                            </span>
                                        </button>
                                        <!-- <a href="#" onclick="printDiv()" class="ml-2">
                                            <span class="icon h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center rounded-circle ">
                                                <svg width="15px" height="15px" viewBox="0 0 16 16" class="bi bi-printer-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5z"></path>
                                                    <path fill-rule="evenodd" d="M11 9H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"></path>
                                                    <path fill-rule="evenodd" d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"></path>
                                                </svg>
                                            </span>
                                        </a>
                                        <a href="#" class="ml-2">
                                            <span class="icon h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center rounded-circle ">
                                                <svg width="15px" height="15px" viewBox="0 0 16 16" class="bi bi-file-earmark-text-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm7 2l.5-2.5 3 3L10 5a1 1 0 0 1-1-1zM4.5 8a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7zM4 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"></path>
                                                </svg>
                                            </span>
                                        </a> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 ">
                            <div class="card card-custom gutter-b bg-white border-0">
                                <div class="card-body">
                                    <div>
                                        <div class=" table-responsive" id="printableTable">
                                        
                                            <div id="productblogTable_wrapper" class="dataTables_wrapper no-footer">

                                            <div class="dataTables_length" id="productblogTable_length"><label>Show 
                                            <select name="productblogTable_length"  class="" v-model="limit" v-on:change="fetchstores()">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="200">200</option>
                                            <option value="500">500</option>
                                            <option value="1000">1000</option>
                                            </select> entries</label></div>

                                            <div id="productblogTable_filter" class="dataTables_filter">
                                                <label>Search:<input type="text" class="" placeholder=""  v-model="searchParameter" @keyup="fetchstores()"></label>
                                                <button
                                                v-if="this.searchParameter != ''"
                                                @click="clearSearch"
                                                >
                                                clear
                                                </button>
                                            </div>

                                                <table id="productblogTable" class="display dataTable no-footer" role="grid">
                                                    <thead class="text-body">
                                                        <tr role="row">
                                                            <th class="sorting" tabindex="0"  rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending"  @click="sorting('id')" :class="(this.$data.sortType == 'asc' || this.$data.sortType == 'ASC') && this.$data.sortBy == 'id'  ? 'sorting_asc' : (this.$data.sortType == 'address' || this.$data.sortType == 'address') && this.$data.sortBy == 'id' ? 'sorting_desc' : 'sorting'">
                                                                ID
                                                            </th>

                                                            <th class="no-sort sorting_disabled" rowspan="1" colspan="1">
                                                                Image
                                                            </th>
                                                            
                                                            <th class="sorting" >
                                                            Name
                                                            </th>
                                                            <th class="sorting" >
                                                                Latitude
                                                            </th>
                                                            <th class="sorting" >
                                                                Longitude
                                                            </th>
                                                            <th class="sorting" >
                                                                Phone
                                                            </th>
                                                            <th class="sorting" >
                                                                Google Map URL
                                                            </th>
                                                            <th class="no-sort sorting_disabled" rowspan="1" colspan="1">
                                                                Address
                                                            </th>
                                                            <th v-if="$parent.permissions.includes('blog-manage')" class="no-sort sorting_disabled" rowspan="1" colspan="1" aria-label="Action" >
                                                                Action
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="kt-table-tbody text-dark">
                                                        <tr class="kt-table-row kt-table-row-level-0 odd" role="row" v-for="store in stores" v-bind:key="store.id">
                                                            <td class="sorting_1">
                                                                {{store.id}}
                                                            </td>
                                                            <td>
                                                                 <img :src="store.gallary ? cdnUrl('/gallary/'+store.gallary.name):''" style="width:60px" />
                                                            </td>
                                                            
                                                            <td>
                                                                {{ store.name }}
                                                            </td>
                                                            <td>
                                                                {{ store.latitude}}
                                                            </td>
                                                            <td>
                                                                {{ store.longitude}}
                                                            </td>
                                                            <td>
                                                                {{ store.phone}}
                                                            </td>
                                                            <td>
                                                                <a v-if="store.google_map_url" :href="store.google_map_url" target="_blank" class="btn btn-sm btn-primary">
                                                                    <i class="fa fa-map-marker"></i>
                                                                </a>
                                                                <span v-else>-</span>
                                                            </td>
                                                            <td>
                                                                {{ store.address }}
                                                            </td>
                                                            <td v-if="$parent.permissions.includes('blog-manage')">
                                                                <a href="javascript:void(0)" class=" click-day" id="click-day" data-toggle="tooltip" title="" data-placement="right" data-original-title="Check out more demos" @click="editday(store)"><i class="fa fa-calendar-days"></i></a>
                                                                <a href="javascript:void(0)" class=" click-edit" id="click-edit1" data-toggle="tooltip" title="" data-placement="right" data-original-title="Check out more demos" @click="editstore(store)"><i class="fa fa-edit"></i></a>
                                                                        <a class="" href="#" @click="deletestore(store.id)"><i class="fa fa-trash"></i></a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                
                                                <ul class="pagination pagination-sm m-0 float-right">
                                                    <li v-bind:class="[{disabled: !pagination.prev_page_url}]"><button class="page-link"  @click="fetchcategorys(pagination.prev_page_url)">Previous</button></li>

                                                    <li class="disabled"><a class="page-link text-dark" href="#">Page {{ pagination.current_page }} of {{ pagination.last_page }}</a></li>

                                                    <li v-bind:class="[{disabled: !pagination.next_page_url}]" class="page-item"><button class="page-link"  @click="fetchstores(pagination.next_page_url)">Next</button></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="offcanvas offcanvas-right kt-color-panel p-5 kt_notes_panel" v-if="display_form" :class="display_form ? 'offcanvas-on' : ''">
        <div class="offcanvas-header d-flex align-items-center justify-content-between pb-3">
            <h4 class="font-size-h4 font-weight-bold m-0">{{ this.edit ? "Edit Store" : "Add Store" }}</h4>
            <a href="#" class="btn btn-sm btn-icon btn-light btn-hover-primary kt_notes_panel_close" v-on:click="clearForm()">
                <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                </svg>
            </a>
        </div>
        <form id="myform">
            <div class="row">
                <div class="col-12">
                    <div class="tabslang">
                        <div v-for="language in languages" class="tablang" :class="language.id == selectedLanguage ?'active':''" @click="setSelectedLanguage(language.id)">
                            {{ language.language_name }}
                        </div>
                    </div>
                    <br />
                    <div class="form-group " >
                        <label class="text-dark">Name</label>
                        <input type="text" :name="store.name" v-model="store.name" class="form-control" />
                        <small class="form-text text-danger" v-if="errors.has('name')" v-text="errors.get('name')"></small>
                    </div>

                    <br />
                    <div class="form-group " >
                        <label class="text-dark">Address</label>
                        <!-- <input type="text" :name="'address'+index" v-model="store.address[index]" class="form-control" /> -->
                        <vue-editor v-model="store.address"></vue-editor>
                        <small class="form-text text-danger" v-if="errors.has('address')" v-text="errors.get('address')"></small>
                    </div>

                    
                    

                    <div class="form-group " >
                        <label class="text-dark">Latitude</label>
                        <input type="text" :name="store.latitude" v-model="store.latitude" class="form-control" />
                        <small class="form-text text-danger" v-if="errors.has('latitude')" v-text="errors.get('latitude')"></small>
                    </div>

                    
                    <div class="form-group " >
                        <label class="text-dark">Longitude</label>
                        <input type="text" :name="store.longitude" v-model="store.longitude" class="form-control" />
                        <small class="form-text text-danger" v-if="errors.has('longitude')" v-text="errors.get('longitude')"></small>
                    </div>

                    <div class="form-group " >
                        <label class="text-dark">Phone</label>
                        <input type="text" :name="store.phone" v-model="store.phone" class="form-control" />
                        <small class="form-text text-danger" v-if="errors.has('phone')" v-text="errors.get('phone')"></small>
                    </div>

                    <div class="form-group " >
                        <label class="text-dark">Google Map URL</label>
                        <input type="text" :name="store.google_map_url" v-model="store.google_map_url" class="form-control" placeholder="https://www.google.com/maps/..." />
                        <small id="googleMapHelp" class="form-text text-muted">Enter the full Google Maps URL for this store location.</small>
                        <small class="form-text text-danger" v-if="errors.has('google_map_url')" v-text="errors.get('google_map_url')"></small>
                    </div>

                   
                    
                    <div class="form-group">
                        <button type="button" class="btn btn-primary" @click="toggleImageSelect()">Upload store Media</button>
                        <small id="textHelp" class="form-text text-muted">Select Image file from gallary.</small>
                        <small class="form-text text-danger" v-if="errors.has('gallary_id')" v-text="errors.get('gallary_id')"></small>

                        <img v-if="gallary_path != ''" :src="cdnUrl(gallary_path)" style="width:100px;height:100px;"/>
                    </div>
                </div>
            </div>
            <button type="button" @click="addUpdatestore()" class="btn btn-primary">Submit</button>
        </form>
    </div>






    <div class="offcanvas offcanvas-right kt-color-panel p-5 kt_notes_panel" v-if="display_form_day" :class="display_form_day ? 'offcanvas-on' : ''">
        <div class="offcanvas-header d-flex align-items-center justify-content-between pb-3">
            <h4 class="font-size-h4 font-weight-bold m-0">workdays</h4>
            <a href="#" class="btn btn-sm btn-icon btn-light btn-hover-primary kt_notes_panel_close" v-on:click="clearForm()">
                <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                </svg>
            </a>
        </div>
        <form id="myformday">
            <div class="row">
                <div class="col-12">
                    <div v-for="(day, index) in days" :key="index">


                        <h3 class="text-dark">{{ day.name }}</h3>

                        <div class="form-group " >
                            <label class="text-dark">Store opening time</label>

                        <input type="time" v-model="selectedTimes[day.name].open_time" class="form-control">
                    </div>

                    <div class="form-group " >
                        <label class="text-dark">Store closing time</label>
                         <input type="time" v-model="selectedTimes[day.name].close_time" class="form-control">                        <small class="form-text text-danger" v-if="errors.has('address')" v-text="errors.get('address')"></small>
                    </div>


                </div>
            </div>
            </div>
            <button type="button" @click="addUpdateday()" class="btn btn-primary">Submit</button>
        </form>
    </div>









    <attach-image @toggleImageSelect="toggleImageSelect" :showModal="showModal" @setImage="setImage"/>
</div>
</template>

<script>
import ErrorHandling from "../../ErrorHandling";
// Basic Use - Covers most scenarios
import { VueEditor } from "vue2-editor";

export default {
    components: {
        VueEditor
     },
    data() {
        return {
            display_form: 0,
            display_form_day: 0,
            store: {
                id: "",
                name:"",
                latitude:"",
                longitude:"",
                address:"",
                gallary_id:"",
                phone:"",
            },
            searchParameter: '',
            sortBy: 'id',
            sortType: 'ASC',
            limit: 10,
            error_message: '',
            edit: false,
            actions: false,
            pagination: {},
            request_method: "",
            countrySelected: "",
            stateSelected: "",
            days: [],
            stores:[],
            languages: [],
            token: [],
            gallary_path:"",
            icon_path:"",
            showModal:false,
            showModalIcon:false,
            selectedLanguage:'',
            errors: new ErrorHandling(),
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
      selectedTimes: {
        Monday: { open_time: '', close_time: '' },
        Tuesday: { open_time: '', close_time: '' },
        Wednesday: { open_time: '', close_time: '' },
        Thursday: { open_time: '', close_time: '' },
        Friday: { open_time: '', close_time: '' },
        Saturday: { open_time: '', close_time: '' },
        Sunday: { open_time: '', close_time: '' }
      }
        };
    },

    methods: {
       
        fetchstores(page_url) {
            this.$parent.loading = true;
            let vm = this;
            page_url = page_url || "/api/admin/stores";
            var arr = page_url.split('?');
            
            if (arr.length > 1) {
                page_url += '&limit='+this.limit;
            }
            else{
                page_url += '?limit='+this.limit;
            }
            if(this.searchParameter != null){
                page_url += '&searchParameter='+this.searchParameter;
            }
            page_url += '&sortBy='+this.sortBy+'&sortType='+this.sortType+'&getDetail=1&getGallaryDetail=1';
            var responseData = {};

            axios.get(page_url, this.token).then(res => {
                this.stores = res.data.data;
                vm.makePagination(res.data.meta, res.data.links);
            }).finally(() => (this.$parent.loading = false));
        },

        makePagination(meta, links) {
            let pagination = {
                current_page: meta.current_page,
                last_page: meta.last_page,
                next_page_url: links.next,
                prev_page_url: links.prev
            };

            this.pagination = pagination;
        },
        deletestore(id) {
            if (confirm('Are You Sure?')) {
                this.$parent.loading = true;
                axios.delete(`/api/admin/stores/${id}`,this.token)
                    .then(res => {
                        if (res.data.status == "Success") {
                            this.$toaster.success('Store has been updated successfully')
                            this.fetchstores();
                        }

                    })
                    .catch(err => console.log(err))
                    .finally(() => (this.$parent.loading = false));
            }
        },
        addUpdatestore() {
            this.$parent.loading = true;
            var url = '/api/admin/stores';
            if (this.edit === false) {
                // Add
                this.request_method = 'post'
            } else {
                // Update
                var url = '/api/admin/stores/' + this.store.id;
                this.request_method = 'put'
            }

            axios[this.request_method](url,this.store,
                this.token)
                .then(res => {
                    if (res.data.status == "Success") {
                        this.display_form = 0;
                        this.$toaster.success('Store has been updated successfully')
                        this.clearForm();
                        this.fetchstores();
                    } else {
                        this.$toaster.error(res.data.message)
                    }
                })
                .catch(error => {
					this.error_message = '';
					this.errors = new ErrorHandling();
					if (error.response.status = 422) {
						if(error.response.data.status == 'Error'){
							this.error_message = error.response.data.message;
						}
						else{
							this.errors.record(error.response.data.errors);
						}
					}
				}).finally(() => (this.$parent.loading = false));

        },
        addUpdateday() {

            console.log(this.selectedTimes);
            this.$parent.loading = true;
            var url = '/api/admin/store_days/'+ this.store.id;
            
                // Update
              //  var url = '/api/admin/stores/' + this.store.id;
                this.request_method = 'post'

            axios[this.request_method](url,this.selectedTimes,
                this.token)
                .then(res => {
                    if (res.data.status == "Success") {
                        this.display_form = 0;
                        this.$toaster.success('Store has been updated successfully')
                        this.clearForm();
                        this.fetchstores();
                    } else {
                        this.$toaster.error(res.data.message)
                    }
                })
                .catch(error => {
					this.error_message = '';
					this.errors = new ErrorHandling();
					if (error.response.status = 422) {
						if(error.response.data.status == 'Error'){
							this.error_message = error.response.data.message;
						}
						else{
							this.errors.record(error.response.data.errors);
						}
					}
				}).finally(() => (this.$parent.loading = false));

        },
        editstore(store) {
                this.edit = true;
                this.display_form = 1;
                this.errors = new ErrorHandling();
                this.store.id = store.id;
                this.store.name=store.name;
                this.store.latitude=store.latitude;
                this.store.longitude=store.longitude;
                this.store.address=store.address;
                this.store.gallary_id="";
                this.store.phone=store.phone;

            axios.get(`/api/admin/stores/${store.id}?getGallaryDetail=1`,this.token)
            .then(res => {
                if (res.data.status == "Success") {
                    this.store.latitude = res.data.data.latitude;
                    this.store.longitude = res.data.data.longitude;
                    this.store.gallary_id = res.data.data.gallary.id;
                    this.store.phone = res.data.data.phone;
                    this.store.name = res.data.data.name;
                    this.store.address = res.data.data.address;
                    this.gallary_path ='/gallary/'+res.data.data.gallary.name;
                    
                }

            })
            .catch(err => console.log(err));
            
            
        },
        editday(store) {
                this.edit = true;
                this.display_form_day = 1;
                this.store.id=store.id
                

               var storeCount= store.day.length;

               console.log(storeCount)

               if(storeCount > 0){
                var i=0;
                for(i;i< storeCount;i++){
                this.selectedTimes[store.day[i].day].open_time=store.day[i].open_time
                this.selectedTimes[store.day[i].day].close_time=store.day[i].close_time
                }
               }else{

                this.days.forEach(day => {
    if (this.selectedTimes[day.name]) {
        this.selectedTimes[day.name].open_time = "";
        this.selectedTimes[day.name].close_time = "";
    }
});
               
               }
               
                
          
            
        },
        clearForm() {
            this.display_form = 0;
            this.display_form_day = 0;
            this.edit = false;
            this.store.id = null;
            this.store.latitude = "";
            this.store.longitude = "";
            this.store.gallary_id = "";
            this.store.phone = "";
            this.store.name = "";
            this.store.address = "";
            this.gallary_path=""

            },
        sorting(sortBy){
            this.sortBy = sortBy;
            this.sortType = this.sortType == 'asc' || this.sortType == 'ASC' ? this.sortType='address' : this.sortType = 'asc';
            this.fetchstores();
        },
        setSelectedLanguage(selectedLanguage){
            this.selectedLanguage = selectedLanguage;
            console.log("i am clicked",selectedLanguage)
        },
        toggleImageSelect(){
            this.showModal = !this.showModal;
        },
        setImage(gallary){
            console.log(gallary);
            this.gallary_path = gallary.gallary_path,
            this.store.gallary_id = gallary.gallary_id;
        },
        fetchdays(page_url) {
            this.$parent.loading = true;
            let vm = this;
            page_url = page_url || "/api/admin/get_days";
            page_url += '?getDetail=1&onlyActive=1';
            axios.get(page_url, this.token).then(res => {
                this.days = res.data.data;
                console.log(this.days)
            }).finally(() => (this.$parent.loading = false));
        },
        clearSearch(){
            this.searchParameter = "",
            this.fetchstores();
        }
    },
    mounted() {
        
        var token = localStorage.getItem('token');
        this.token = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
        this.fetchstores();
        this.fetchdays();
    }
};
</script>
